import { render, staticRenderFns } from "./CertificateInfo.vue?vue&type=template&id=8cc4598a&"
import script from "./CertificateInfo.vue?vue&type=script&lang=ts&"
export * from "./CertificateInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports